import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * The action row of a long dialog — Cancel / Submit — kept in view.
 *
 * FF-AUDIT-20260914-210459-086: on a 390-px phone the Report-incident sheet
 * was 90 vh tall with its buttons below the fold and nothing to say more
 * followed; the last visible control was a half-cut "Add photos". `Dialog`'s
 * panel is the scroll container, so a `sticky bottom-0` row inside it stays
 * at the panel's bottom edge while the fields scroll underneath. The negative
 * margins cancel the panel padding so the row spans edge to edge, and the
 * top border marks it as a footer once content has scrolled behind it. The
 * sticky edge is offset by the same padding (`-bottom-4`, `sm:-bottom-6`):
 * a sticky element is held inside the scroll container's padding box, so
 * `bottom-0` lifted the row off the panel's bottom edge by the padding and
 * over the last controls above it (2026-09-27; see `Dialog`'s header).
 *
 * Use it for any dialog that can outgrow a phone; a short dialog gains
 * nothing and loses nothing (the row simply sits at the end).
 */
export function DialogActions({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'sticky -bottom-4 z-10 -mx-4 -mb-4 mt-4 flex flex-wrap justify-end gap-2 border-t bg-card px-4 py-3 sm:-bottom-6 sm:-mx-6 sm:-mb-6 sm:px-6',
        className,
      )}
    >
      {children}
    </div>
  )
}
